import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useProfile } from '../contexts/ProfileContext';
import StartupProfile from '../components/profile/StartupProfile';
import InvestorProfile from '../components/profile/InvestorProfile';
import AccessErrorScreen from '../components/AccessErrorScreen';

const MyProfilePage: React.FC = () => {
  const { user, loading: authLoading, userLoadError, refreshUser } = useAuth();
  const {
    loading: profileLoading,
    profileLoadAttempted,
    error: profileError,
    reloadProfile,
  } = useProfile();

  if (authLoading) {
    return (
      <div className="min-h-screen bg-[#262626] flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-emerald-500 mb-4" />
          <p className="text-white text-lg">Loading profile...</p>
        </div>
      </div>
    );
  }

  if (userLoadError) {
    return (
      <AccessErrorScreen
        title="Unable to load your account"
        message={userLoadError}
        onRetry={() => void refreshUser()}
      />
    );
  }

  if (profileLoadAttempted && profileError) {
    return (
      <AccessErrorScreen
        title="Unable to load your profile"
        message={profileError}
        onRetry={() => void reloadProfile()}
      />
    );
  }

  if (profileLoading || !profileLoadAttempted) {
    return (
      <div className="min-h-screen bg-[#262626] flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-emerald-500 mb-4" />
          <p className="text-white text-lg">Loading profile...</p>
        </div>
      </div>
    );
  }

  if (user?.userType === 'investor') {
    return (
      <div className="min-h-screen bg-[#262626]">
        <InvestorProfile />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#262626]">
      <StartupProfile />
    </div>
  );
};

export default MyProfilePage;
